import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

// How a candidate's assessment submission was triggered. The frontend can only
// originate the first three; `backend_timeout_cleanup` is set server-side when
// no submission is ever received. See the Assessment Submission & State Tracking
// spec for the state each mode maps to (completed / interrupted / abandoned).
export type SubmissionMode =
  | 'manual_submit'
  | 'auto_submit_timeout'
  | 'auto_submit_tab_exit'
  | 'backend_timeout_cleanup';

export interface CompleteCandidateSubmissionArgs {
  responseId: number;
  submissionMode: SubmissionMode;
}

export const useCompleteCandidateSubmission = () => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async ({ responseId, submissionMode }: CompleteCandidateSubmissionArgs) => {
      const response = await apiClient.post('/candidate/complete/', {
        response_id: responseId,
        submission_mode: submissionMode,
      });
      return response.data;
    },
    onError: (err: any) => {
      const serverMsg = err?.response?.data?.error || err?.response?.data?.detail || err?.response?.data?.message;
      openToast({
        show: true,
        heading: 'Submission Validation Failed',
        text: serverMsg || 'Failed to validate assessment submission',
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};